import React, { useEffect, useState, useRef } from "react";
import styles from "../../styles/office/OfficeHeader.module.css";
import backgroundImage from "../../assets/image/bg2.png";
import profileIcon from "../../assets/image/profile-icon2.png";
import OfficeProfile from "./OfficeProfile";
import settingsIcon from "../../assets/image/settings-icon.png";
import { useNavigate } from "react-router-dom";
import ChangePasswordPopup from "./ChangePasswordPopup";
//import emblem from '../../assets/image/emblem.png';
import emblem from '../../assets/image/logo1.png';

import SangliLogo from '../../assets/image/logo1.png';
import { currentLanguage } from '../../services/LanguageTranslationService';
//import userManual from '../../assets/documents/Officer_User_Manual.pdf';
import userManual from '../../assets/documents/DP_Part Plan_SMKMC.pdf';

const OfficeHeader = () => {
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [isProfileVisible, setIsProfileVisible] = useState(false);
    const [officeName, setOfficeName] = useState("Loading...");
    const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
    const token = localStorage.getItem("token_office");
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOfficeName = async () => {
            try {
         
                const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/get_office_fullname.php`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    //body: formData, // Make sure `formData` is a valid FormData object
                    credentials: 'include'
                });
                const { full_name } = await response.json();
                setOfficeName(full_name);
            } catch (error) {
                console.error("Failed to fetch office name:", error);
            }
        };

        fetchOfficeName();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowSettingsDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleChangePassword = async (currentPassword, newPassword) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/change_office_password.php`,
                {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        currentPassword,
                        newPassword
                    }),
                }
            );

            const result = await response.json();

            if (result.status !== "success") {
                throw new Error(result.message || "Failed to change password");
            } else {
                window.location.href = "https://part-plan-two.vishvaconnect.com/client/build";
            }
        } catch (error) {
            throw error;
        }
    };

    const handleProfileClick = () => setIsProfileVisible(true);
    const handleCloseProfile = () => setIsProfileVisible(false);
    const toggleSettingsDropdown = () => setShowSettingsDropdown(!showSettingsDropdown);

    const handleLogout = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/logout.php`,
                { method: 'POST', credentials: "include" }
            );
            const result = await response.json();

            if (result.status === "success") {
                setTimeout(() => {
                    if (result.redirect) {
                        navigate(result.redirect);
                    }
                }, 1500);
            } else {
                throw new Error(result.message || " Please try again.");
            }
        } catch (error) {
            console.error("Failed to fetch applicant name:", error);
        }
    };

    const handleSettingsOption = (option) => {
        setShowSettingsDropdown(false);
        if (option === 'Logout') {
            handleLogout();
        }
        if (option === 'ChangePassword') {
            setShowChangePassword(true);
        }


        if (option === 'UserManual') {
            const link = document.createElement('a');
            link.href = userManual;
            link.download = 'Office_Manual.pdf'; // File name on download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }


    };

    return (
        <header className={styles.headerContainer}>
            <img
                src={backgroundImage}
                alt="Header background"
                className={styles.backgroundImage}
            />

            <div className={styles.headerContent}>
                {/* Profile section at top left */}
                <div className={styles.profileContainer}>
                    <div className={styles.profileSection} onClick={handleProfileClick}>
                        <img
                            src={profileIcon}
                            alt="Profile"
                            className={styles.profileIcon}
                        />
                        <div className={styles.applicantName}>{officeName}</div>
                    </div>
                </div>

                {/* Settings at top right */}
                <div className={styles.settingsWrapper} ref={dropdownRef}>
                    <button
                        className={styles.settingsButton}
                        onClick={toggleSettingsDropdown}
                        aria-label="Settings"
                    >
                        <img
                            src={settingsIcon}
                            alt="Settings"
                            className={styles.settingsIcon}
                        />
                    </button>Settings
                    {showSettingsDropdown && (
                        <div className={styles.settingsDropdown}>
                            <button onClick={() => handleSettingsOption('ChangePassword')}>Change Password</button>
                            <button onClick={() => handleSettingsOption('ResetPreview')}>Reset Preview</button>
                            <button onClick={() => handleSettingsOption('UserManual')}>User Manual</button>
                            <button onClick={() => handleSettingsOption('Logout')}>Logout</button>
                        </div>
                    )}
                </div>

                {/* Center content */}
                <div className={styles.centerContent}>

                    <div className={styles.clogobox}>
                        <div className={styles.clogo}>
                            <img src={emblem} alt="Government Emblem" className={styles.cemblem} />
                            <div className={styles.ctitlecontainer}>
                                <h1>
                                    {currentLanguage === 'en'
                                        ? 'Part Plan And Zone Certificate Portal'
                                        : 'भाग योजना आणि क्षेत्र प्रमाणपत्र पोर्टल'}
                                </h1>

                                <p className={styles.csubtitle}>
                                    {currentLanguage === 'en'
                                        ? 'Sangli, Miraj and Kupwad Municipal Corporation'
                                        : 'महाराष्ट्र शासन'}
                                </p>
                                <p className={styles.csubSubtitle}>
                                    {currentLanguage === 'en'
                                        ? 'Town Planning Department'
                                        : 'नगर रचना आणि मूल्यांकन विभाग'}
                                </p>
                            </div>
                            {/* <img src={SangliLogo} alt="Government Emblem" className={styles.cemblem} /> */}
                        </div>
                    </div>

                    <br />
                </div>
            </div>

            {isProfileVisible && <OfficeProfile onClose={handleCloseProfile} />}
            {showChangePassword && (
                <ChangePasswordPopup
                    onClose={() => setShowChangePassword(false)}
                    onSubmit={handleChangePassword}
                />
            )}
        </header>
    );
};

export default OfficeHeader;